import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=22a23576&scoped=true&"
import script from "./Match.vue?vue&type=script&lang=js&"
export * from "./Match.vue?vue&type=script&lang=js&"
import style0 from "./Match.vue?vue&type=style&index=0&id=22a23576&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a23576",
  null
  
)

export default component.exports